module.exports = __webpack_public_path__ + "static/media/kaplan.7176b1cc.webp";